module.exports = __webpack_public_path__ + "static/media/greenTick.fa97a760.svg";